<script setup lang="ts">
interface Props {
  shadowColor?: string;
  size?: 'sm' | 'md' | 'lg' | 'custom';
}

withDefaults(defineProps<Props>(), {
  shadowColor: '#B89EC6',
  size: 'md',
});

// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()
</script>

<template>
  <q-btn :class="`base-btn size-${size}`">
    <slot></slot>
  </q-btn>
</template>
<style lang="scss">
.base-btn {
  text-transform: uppercase;
  border-radius: 0.5rem;
  box-shadow: 0.25em 0.25em 0px 0px v-bind(shadowColor);
  &.size-sm {
    border-radius: 0.75rem;
    min-height: 3.5rem;
    min-width: 12rem;
    font-size: 1.125rem;
  }
  &.size-md {
    border-radius: 1rem;
    min-height: 5rem;
    min-width: 17.5rem;
    font-size: 1.375rem;
  }
  &.size-lg {
    border-radius: 1.25rem;
    min-height: 6rem;
    min-width: 20rem;
    font-size: 1.625rem;
  }
}
</style>
